import React from 'react';
import NewRelicSVG from '../../../../components/NewRelicSVG';

const nerdlogIcon = (props) => (
  <NewRelicSVG {...props}>
    <>
      <polygon points="23 7 16 12 23 17 23 7" />
      <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
    </>
  </NewRelicSVG>
);

export default nerdlogIcon;
